import React from 'react';

export const LockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M13.4307 8.18034C13.4307 7.8414 13.296 7.51633 13.0564 7.27666C12.8167 7.03699 12.4916 6.90234 12.1527 6.90234H3.84734C3.50839 6.90234 3.18332 7.03699 2.94365 7.27666C2.70398 7.51633 2.56934 7.8414 2.56934 8.18034V14.569C2.56934 14.908 2.70398 15.233 2.94365 15.4727C3.18332 15.7124 3.50839 15.847 3.84734 15.847H12.1527C12.4916 15.847 12.8167 15.7124 13.0564 15.4727C13.296 15.233 13.4307 14.908 13.4307 14.569V8.18034Z"
      fill="white"
      stroke="#4B4B4B"
    />
    <path
      d="M4.48596 4.66634C4.48596 3.73437 4.85619 2.84057 5.51519 2.18157C6.17419 1.52257 7.06799 1.15234 7.99996 1.15234C8.93193 1.15234 9.82573 1.52257 10.4847 2.18157C11.1437 2.84057 11.514 3.73437 11.514 4.66634V6.90234H4.48596V4.66634Z"
      stroke="#4B4B4B"
    />
    <path
      d="M7.20129 11.3748C7.20129 11.5867 7.28544 11.7898 7.43522 11.9396C7.585 12.0894 7.78814 12.1735 7.99996 12.1735C8.21178 12.1735 8.41492 12.0894 8.5647 11.9396C8.71448 11.7898 8.79863 11.5867 8.79863 11.3748C8.79863 11.163 8.71448 10.9599 8.5647 10.8101C8.41492 10.6603 8.21178 10.5762 7.99996 10.5762C7.78814 10.5762 7.585 10.6603 7.43522 10.8101C7.28544 10.9599 7.20129 11.163 7.20129 11.3748Z"
      stroke="#4B4B4B"
    />
  </svg>
);
